<template>
    <div class="plane-picture-container">
        <div class="plane-picture" v-if="!!plane">
            <img ref="img" :src="`/api/planes/${plane.id}/main-picture`">

            <div class="plane-picture-info-container">
                <div class="plane-passengers-max">
                    <img src="/imgs/icons/passager.svg">
                    <span v-html="$t('registration.passengers-max', {maxPassengers: plane.max_passengers})" />
                </div>
                <div class="plane-weight-max">
                    <img src="/imgs/icons/poids.svg">
                    <span v-html="$t('registration.weight-max', {maxWeight: plane.max_weight})" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        planeString: {
            type: String,
        },
    },
    computed: {
        plane() {
            if (!this.planeString) {
                return;
            }

            return JSON.parse(this.planeString);
        },
    },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/registration/Profile/plane-picture.vue